export const language = {
    "Custom Design": "自定義設計",
    "Cancel": "取消",
    "Update": "更新",
    "Save": "保存",
}